import * as R from "ramda";
import * as imu from "utils/immutable_utils";

export const getTabTitle = R.pipe(
  imu.unImmute,
  R.propOr("TelenorConnexion", "tabTitle")
);
